import { useIsomorphicLayoutEffect } from "@swiggy-private/core-ui";
import { CartHeaderState } from "@cart-client/contexts/CartHeaderContext";

enum LottieIds {
    CART_HEADER_LOTTIE = "CART_HEADER_LOTTIE",
}

interface UseSkipAnimationFinalStateParams {
    skipAnimationShowFinalState?: boolean;
    shouldShowLottie: boolean;
    isSuccess: boolean;
    isBlck: boolean;
    isOtg: boolean;
    isExpress: boolean;
    isBolt: boolean;
    enabledOverlayId: string | null;
    onCloseOverlay: VoidFunction;
    setCartHeaderState: React.Dispatch<React.SetStateAction<CartHeaderState>>;
    setBoltStateUpdated: React.Dispatch<React.SetStateAction<boolean>>;
    setBlckStateUpdated: React.Dispatch<React.SetStateAction<boolean>>;
    isBoltStateShownRef: React.MutableRefObject<boolean>;
    isBlckStateShownRef: React.MutableRefObject<boolean>;
}

/**
 * Hook to handle skipping header lottie animation and showing final state directly.
 * Used when magic items lottie has not played yet in the session.
 */
export const useSkipAnimationFinalState = ({
    skipAnimationShowFinalState,
    shouldShowLottie,
    isSuccess,
    isBlck,
    isOtg,
    isExpress,
    isBolt,
    enabledOverlayId,
    onCloseOverlay,
    setCartHeaderState,
    setBoltStateUpdated,
    setBlckStateUpdated,
    isBoltStateShownRef,
    isBlckStateShownRef,
}: UseSkipAnimationFinalStateParams): void => {
    useIsomorphicLayoutEffect(() => {
        if (skipAnimationShowFinalState && shouldShowLottie && isSuccess) {
            setCartHeaderState((prev) => ({
                ...prev,
                isBlack: isBlck,
                isOtg: isOtg,
                isExpress: isExpress,
                isBolt: isBolt,
                showAnimation: true,
                themeChange: true,
                showFinalState: true,
                startAnimation: false,
                hideTheme: false,
                isStatusSuccess: isSuccess,
            }));

            // Mark states as updated to prevent re-triggering
            if (isBolt) {
                setBoltStateUpdated(true);
                isBoltStateShownRef.current = true;
            } else {
                setBlckStateUpdated(true);
                isBlckStateShownRef.current = true;
            }

            // Close overlay if it was registered
            if (enabledOverlayId === LottieIds.CART_HEADER_LOTTIE) {
                onCloseOverlay();
            }
        }
    }, [
        skipAnimationShowFinalState,
        shouldShowLottie,
        isSuccess,
        isBlck,
        isOtg,
        isExpress,
        isBolt,
        enabledOverlayId,
        onCloseOverlay,
        setCartHeaderState,
        setBoltStateUpdated,
        setBlckStateUpdated,
        isBoltStateShownRef,
        isBlckStateShownRef,
    ]);
};
